import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import AlertMessage from "app/pages/.shared/AlertMessage";
import { ALERT_TYPE, STRATEGY } from "app/constants";
import { FormattedMessage, injectIntl } from "react-intl";
import IdentityFieldset from "app/pages/.shared/profile/IdentityFieldset";
import Email from "app/pages/.shared/profile/Email";
import PhoneIntl from "app/pages/.shared/profile/PhoneIntl";
import Separator from "app/pages/.shared/Separator";
import AddressFieldset from "app/pages/.shared/profile/AddressFieldset";
import { strategyShape } from "app/utils/propTypes";
import { contactFields } from "app/pages/Booking/Payment/paymentSchema";
import get from "lodash/get";
import "./PaymentContact.scss";
import LoadingPlaceholder from "app/pages/.shared/LoadingPlaceholder";

class PaymentContact extends PureComponent {
	render() {
		const {
			strategy,
			errors = [],
			nameField = {},
			emailField = {},
			phoneField = {},
			addressField = {},
			onCountryChange,
			handleInputBlur,
			intl,
			isLoading,
			shop,
			isAuthenticated,
		} = this.props;

		const contactErrorList = [];

		contactFields.forEach(path => {
			const error = get(errors, path);
			if (error) {
				contactErrorList.push(intl.formatMessage(error));
			}
		});

		return (
			<div className="payment-contact">
				{isLoading ? (
					<LoadingPlaceholder
						message={<FormattedMessage id="payment.contact.loading.text" />}
					/>
				) : (
					<React.Fragment>
						{contactErrorList.length > 0 && (
							<AlertMessage
								alertType={ALERT_TYPE.ERROR}
								message={
									<FormattedMessage id="error.booking.payment.fields.required" />
								}
								errors={contactErrorList}
							/>
						)}

						<h1 className="payment__subtitle">
							<FormattedMessage id="payment.contact.contact" />
						</h1>

						<IdentityFieldset
							id="payment-contact"
							fields={nameField}
							isRequired={true}
							onBlur={handleInputBlur}
						/>

						<div className="payment__email-phone">
							{isAuthenticated &&
							(strategy !== STRATEGY.TRANSACTION_FIRST &&
								strategy !== STRATEGY.OAUTH) ? (
								<Email email={emailField} disabled />
							) : (
								<Email email={emailField} onBlur={handleInputBlur} />
							)}
							<PhoneIntl
								id="phone"
								name="phone"
								field={phoneField}
								shop={shop}
								isRequired
								onBlur={handleInputBlur}
								data-cy="phone-number-mobile-input"
							/>
						</div>

						<Separator design="middle" />

						<h1 className="payment__subtitle">
							<FormattedMessage id="payment.contact.address" />
						</h1>

						<AddressFieldset
							id="payment"
							shop={shop}
							fields={addressField}
							onCountryChange={onCountryChange}
							isRequired={true}
							onBlur={handleInputBlur}
						/>
					</React.Fragment>
				)}
			</div>
		);
	}
}

PaymentContact.propTypes = {
	shop: PropTypes.string,
	intl: PropTypes.object,
	strategy: strategyShape,
	isAuthenticated: PropTypes.bool,
	errors: PropTypes.array,
	nameField: PropTypes.object,
	emailField: PropTypes.object,
	phoneField: PropTypes.object,
	addressField: PropTypes.object,
	onCountryChange: PropTypes.func,
	handleInputBlur: PropTypes.func,
	isLoading: PropTypes.bool,
};

export default injectIntl(PaymentContact);
